module.exports = __webpack_public_path__ + "static/media/test10_2.811bb94a.png";